// TODO consider how to compare form values which are not primitive types (will there be any?)

export default formData => Object.entries(formData).filter(([key]) => '_' !== key[0]).every(([key, value]) => !value.isDirty);
